// extracted by mini-css-extract-plugin
export default {"map__wrapper":"KakaoMap_map__wrapper__LEgBo","kakaoMap":"KakaoMap_kakaoMap__XQbHG"};